'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const SkeletonTextHeading = renderWithRef('SkeletonTextHeading', null, (r, o)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "div",
        classNames: [
            'swan-skeleton-text-heading',
            'swan-loading-shimmer'
        ],
        forwardedRef: o,
        props: _object_without_properties(r, [
            "children"
        ]),
        children: n
    });
});

export { SkeletonTextHeading };
